<template>
  <div id="app">
    
    <a href="https://twitter.com/0devco" target="_blank"><img src="https://raw.githubusercontent.com/0devco/docs/master/.devco-images/logo-transparent.png"></a>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import "../node_modules/bulma/css/bulma.css";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue